import React from 'react';
import { NavLink } from 'react-router-dom';
import classes from './LearningTile.module.css';
import HowTo from '../../container/HowTo/HowTo';
import img1 from '../../assets/images/modul-image-1.png';
import img2 from '../../assets/images/modul-image-2.png';
import img3 from '../../assets/images/modul-image-3.png';

const LearningTile = (props) => {
    let imageUrl;

    switch (props.entryID) {
        case 1: imageUrl = img1;
            break;
        case 2: imageUrl = img2;
            break;
        case 3: imageUrl = img3;
            break;
        default: break;
    }
    const imageStyle = {
        backgroundImage: `url(${imageUrl})`
    }

    return (
        <>
            <HowTo />
            <div className={classes.LearningTile}>
                <h2 className={classes.Headline}>{props.title}</h2>
                <NavLink
                    to={'/' + props.slug}>
                    <span className={classes.NavImage} style={imageStyle}></span>
                    <span className={classes.Button}>{props.buttonTitle}</span>
                </NavLink>
            </div>
        </>);
}

export default LearningTile;